<div class="skeleton-wrapper">
  <table class="skeleton">
    @for (row of numberOfRows; track index; let index = $index) {
      <tr class="skeleton__row">
        <td>
          <div class="skeleton__checkbox"></div>
        </td>
        @for (col of numberOfCols; track index2; let index2 = $index) {
          <td>
            <div class="skeleton__cell"></div>
          </td>
        }
      </tr>
    }
  </table>
</div>
